import { withSafeSuspense } from '@calendly/safe-suspense'
import { lazy } from 'react'

export const PersonalContent = withSafeSuspense(
  lazy(
    async () => ({ default: (await import('./content')).PersonalContent })
  )
)
